export default "__VITE_ASSET__dd181823__"